"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const menu_1 = __importDefault(require("./menu"));
const MenuContent = ({ children, scrollable }) => {
    if (!scrollable) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    return ((0, jsx_runtime_1.jsx)("div", { slot: "menu", className: "_hot-scroll", children: children }));
};
exports.default = MenuContent;
